// Constants extracted from ClassRoomModule.js

import React from "react";
import ACLStore from "lib/aclStore";
import { DiscussionFilledIcon, CreateAssessmentSvg } from "SvgComponents";
import {
  QuickTaskOutlined,
  LeOutlined,
  VideoOutlined,
  UnitPlanOutlined,
  FaOutlined,
  SaOutlined,
  LeLibraryOutlined,
  AssessmentAddOutlined,
  CalendarScheduleOutlined,
  WorksheetClipboardOutlined,
  JournalOutlined,
  AiOutlined,
  ClipboardPencilLinesOutlined,
  TickCircleOutlined,
  ClockOutlined,
  PlaceholderFileOutlined,
  ChatOutlined,
  PostTwoOutlined,
} from "@toddle-edu/ds-icons";
import {
  ScheduledAssignmentIllustration,
  CompletedAssignmentIllustration,
  AllCompletedIllustration,
  NothingScheduledIllustration,
  NothingAssignedIllustration,
  NoMessagesIllustration,
  NoEvaluationsIllustration,
} from "@toddle-edu/ds-theme";
import { colors } from "Constants";
import { MY_CALENDAR_CONSTANTS } from "MyCalendar/constants/stringConstants";
import {
  ASSESSMENT_TYPE_AI_TUTOR,
  CREATE_AI_TUTOR,
} from "Constants/stringConstants";
import {
  ENABLE_ASSESSMENTS_IN_PYP,
  TODDLE_LIBRARY_PERM,
} from "Constants/permissionConstants";
import { ASSESSMENT_TYPE_WORKSHEET } from "Worksheet/modules/WorksheetConstants";

// Constants
export const ASSIGNMENT_STATE_TABS = {
  PUBLISHED: {
    label: "common:ong_label",
    studentLabel: "classRoom:todo",
    value: "PUBLISHED",
    orderBy: "PUBLISHED_AT",
    orderByDirection: "DESC",
    orderByDateKey: "publishedAt",
    emptyState: {
      title: "classRoom:todo_empty_state_title",
      subTitle: "classRoom:todo_empty_state_subtitle",
      illustration: AllCompletedIllustration,
    },
  },
  SCHEDULED: {
    label: "common:scheduled",
    studentLabel: "common:scheduled",
    value: "SCHEDULED",
    orderBy: "PUBLISHED_AT",
    orderByDirection: "ASC",
    orderByDateKey: "publishedAt",
    emptyState: {
      title: "classRoom:scheduled_empty_state_title",
      subTitle: "classRoom:scheduled_assignments_empty_state_subtitle",
      illustration: ScheduledAssignmentIllustration,
    },
  },
  ARCHIVED: {
    label: "common:completed",
    studentLabel: "common:done",
    value: "ARCHIVED",
    orderBy: "ARCHIVED_AT",
    orderByDirection: "DESC",
    orderByDateKey: "updatedAt",
    emptyState: {
      title: "classRoom:done_empty_state_title",
      subTitle: "classRoom:done_empty_state_subtitle",
      illustration: CompletedAssignmentIllustration,
    },
  },
};
export const ASSIGNMENT_STATE_TABS_V2 = {
  PUBLISHED: {
    label: "common:ong_label",
    studentLabel: "classRoom:todo",
    value: "PUBLISHED",
    orderBy: "PUBLISHED_AT",
    orderByDirection: "DESC",
    orderByDateKey: "publishedAt",
    emptyState: {
      title: "classRoom:todo_empty_state_title",
      subTitle: "classRoom:todo_empty_state_subtitle",
      illustration: AllCompletedIllustration,
    },
  },
  ARCHIVED: {
    label: "common:completed",
    studentLabel: "common:done",
    value: "ARCHIVED",
    orderBy: "ARCHIVED_AT",
    orderByDirection: "DESC",
    orderByDateKey: "updatedAt",
    emptyState: {
      title: "classRoom:done_empty_state_title",
      subTitle: "classRoom:done_empty_state_subtitle",
      illustration: CompletedAssignmentIllustration,
    },
  },
};
export const SIDEBAR_HEADER_TABS = {
  TASKS: {
    label: "common:task_plural",
    value: "TASKS",
    listType: "plain",
  },
  TAGS: {
    label: "common:tags",
    value: "TAGS",
    listType: "accordion",
  },
};
export const BASE_ASSIGNMENT_STATE_TABS_FOR_STAFF = {
  ALL_POSTS: {
    label: "common:all",
    value: "ALL_POSTS",
    orderBy: "CREATED_AT",
    orderByDirection: "DESC",
    orderByDateKey: "createdAt",
    prefixIcon: <PostTwoOutlined variant="default" />,
    countKey: "all",
    emptyState: {
      title: "classRoom:all_assignments_empty_state_title",
      subTitle: "classRoom:all_assignments_empty_state_subtitle",
      illustration: NothingAssignedIllustration,
    },
    subTitle: "classRoom:all_posts_published_assignments_subtitle",
    sortOptions: [
      {
        key: "CREATED_AT",
        label: "classRoom:creation_date",
        orderByDateKey: "createdAt",
      },
      {
        key: "DUE_AT",
        label: "classRoom:due_date",
        orderByDateKey: "deadline",
      },
    ],
  },
  PUBLISHED: {
    label: "classRoom:to_review_with_hypen",
    value: "PUBLISHED",
    orderBy: "PUBLISHED_AT",
    orderByDirection: "DESC",
    orderByDateKey: "publishedAt",
    filters: {
      isFetchToReviewAssigmentV2: true,
    },
    prefixIcon: <ClipboardPencilLinesOutlined variant="default" />,
    countKey: "toReview",
    emptyState: {
      title: "classRoom:to_review_empty_state_title",
      subTitle: "classRoom:to_review_assignments_empty_state_subtitle",
      illustration: NothingAssignedIllustration,
    },
    subTitle: "classRoom:to_review_tab_subtitle_new",
    sortOptions: [
      {
        key: "PUBLISHED_AT",
        label: "classRoom:assigned_date",
        orderByDateKey: "publishedAt",
      },
      {
        key: "DUE_AT",
        label: "classRoom:due_date",
        orderByDateKey: "deadline",
      },
    ],
  },
  ARCHIVED: {
    label: "classRoom:reviewed",
    value: "ARCHIVED",
    orderBy: "ARCHIVED_AT",
    orderByDirection: "DESC",
    orderByDateKey: "updatedAt",
    prefixIcon: <TickCircleOutlined variant="default" />,
    countKey: "reviewed",
    emptyState: {
      title: "classRoom:reviewed_empty_state_title",
      subTitle: "classRoom:reviewed_assignments_empty_state_subtitle",
      illustration: CompletedAssignmentIllustration,
    },
    subTitle: "classRoom:reviewed_tab_subtitle",
    sortOptions: [
      {
        key: "ARCHIVED_AT",
        label: "classRoom:reviewed_date",
        orderByDateKey: "updatedAt",
      },
      {
        key: "DUE_AT",
        label: "classRoom:due_date",
        orderByDateKey: "deadline",
      },
    ],
  },
  UNREAD_MESSAGES: {
    label: "classRoom:unread_messsages",
    value: "UNREAD_MESSAGES",
    orderBy: "LATEST_UNREAD_CONVERSATION",
    orderByDirection: "DESC",
    filters: {
      isFetchUnreadConverstionAssignment: true,
    },
    prefixIcon: <ChatOutlined variant="default" />,
    countKey: "unreadMessageAssignment",
    showBadge: true,
    emptyState: {
      title: "classRoom:unread_assignments_messages_empty_state_title",
      subTitle: "classRoom:unread_assignments_messages_empty_state_subtitle",
      illustration: NoMessagesIllustration,
    },
    subTitle: "classRoom:unread_messages_tab_subtitle",
    sortOptions: [
      {
        key: "LATEST_UNREAD_CONVERSATION",
        label: "classRoom:message_date",
        orderByDateKey: "lastMessage",
      },
      {
        key: "DUE_AT",
        label: "classRoom:due_date",
        orderByDateKey: "deadline",
      },
    ],
  },
  SCHEDULED: {
    label: "common:scheduled",
    value: "SCHEDULED",
    orderBy: "PUBLISHED_AT",
    orderByDirection: "ASC",
    orderByDateKey: "publishedAt",
    prefixIcon: <ClockOutlined variant="default" />,
    countKey: "scheduled",
    emptyState: {
      title: "classRoom:scheduled_empty_state_title",
      subTitle: "classRoom:scheduled_assignments_empty_state_subtitle",
      illustration: ScheduledAssignmentIllustration,
    },
    subTitle: "classRoom:scheduled_tab_subtitle",
    sortOptions: [
      {
        key: "PUBLISHED_AT",
        label: "classRoom:scheduled_date",
        orderByDateKey: "publishedAt",
      },
      {
        key: "DUE_AT",
        label: "classRoom:due_date",
        orderByDateKey: "deadline",
      },
    ],
  },
  DRAFT: {
    label: "common:drafts",
    value: "DRAFT",
    orderBy: "CREATED_AT",
    orderByDirection: "DESC",
    orderByDateKey: "createdAt",
    prefixIcon: <PlaceholderFileOutlined variant="default" />,
    countKey: "draft",
    emptyState: {
      title: "classRoom:draft_empty_state_title",
      subTitle: "classRoom:draft_assignments_empty_state_subtitle",
      illustration: NoEvaluationsIllustration,
    },
    subTitle: "classRoom:draft_tab_subtitle",
    sortOptions: [
      {
        key: "CREATED_AT",
        label: "classRoom:creation_date",
        orderByDateKey: "createdAt",
      },
      {
        key: "DUE_AT",
        label: "classRoom:due_date",
        orderByDateKey: "deadline",
      },
    ],
  },
};
export const STUDENT_EMPTY_STATE_MAPPING = {
  UPCOMING: {
    title: "classRoom:todo_no_upcoming",
    subTitle: "",
    illustration: AllCompletedIllustration,
  },
  OVERDUE: {
    title: "classRoom:spotless_record",
    subTitle: "classRoom:no_tasks_overdue",
    illustration: AllCompletedIllustration,
  },
  NODUE: {
    title: "classRoom:you_all_caught_up",
    subTitle: "",
    illustration: AllCompletedIllustration,
  },
  THIS_WEEK: {
    title: "common:nothing_here_at_this_moment",
    subTitle: {
      key: "classRoom:completed_todos_subtext_with_label",
      labelKey: "classRoom:this_week",
    },
    illustration: AllCompletedIllustration,
  },
  LAST_WEEK: {
    title: "common:nothing_here_at_this_moment",
    subTitle: {
      key: "classRoom:completed_todos_subtext_with_label",
      labelKey: "classRoom:last_week",
    },
    illustration: AllCompletedIllustration,
  },
  EARLIER: {
    title: "common:nothing_here_at_this_moment",
    subTitle: {
      key: "classRoom:completed_todos_subtext_with_label",
      labelKey: "classRoom:earlier",
    },
    illustration: AllCompletedIllustration,
  },
  NOT_SUBMITTED: {
    title: "classRoom:not_submitted_empty_state_title",
    subTitle: "classRoom:no_tasks_overdue",
    illustration: AllCompletedIllustration,
  },
  SCHEDULED: {
    title: "classRoom:nothing_scheduled_yet",
    subTitle: "classRoom:no_scheduled_assignment_msg",
    illustration: NothingScheduledIllustration,
  },
};
export const ASSIGNMENT_TODO_STATE_TABS = {
  ASSIGNED: {
    label: "classRoom:assigned",
    value: "ASSIGNED",
    orderBy: "PUBLISHED_AT",
    orderByDirection: "DESC",
    userType: ["student", "parent"],
  },
  OVERDUE: {
    label: "classRoom:overdue",
    value: "OVERDUE",
    orderBy: "DUE_AT",
    orderByDirection: "DESC",
    userType: ["student", "parent"],
  },
  COMPLETED: {
    label: "common:completed",
    value: "COMPLETED",
    orderBy: "ARCHIVED_AT",
    orderByDirection: "DESC",
    userType: ["student", "parent"],
  },
  TO_REVIEW: {
    label: "classRoom:to_review",
    value: "TO_REVIEW",
    orderBy: "PUBLISHED_AT",
    orderByDirection: "DESC",
    userType: ["staff"],
  },
  REVIEWED: {
    label: "common:completed",
    value: "REVIEWED",
    orderBy: "ARCHIVED_AT",
    orderByDirection: "DESC",
    userType: ["staff"],
  },
};
export const SCHOOL_CALENDAR_EVENT_CREATE_OPTION = {
  label: "calendar:create_event_v2",
  key: MY_CALENDAR_CONSTANTS.CREATE_EVENT,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const MYP_PROJECT_DEADLINE_CREATE_OPTION = {
  label: "project:create_myp_project_deadline",
  key: MY_CALENDAR_CONSTANTS.CREATE_MYP_PROJECT_DEADLINE,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const MYP_PROJECT_DEADLINE_CREATE_OPTION_NEW = {
  label: "project:create_myp_project_deadline",
  key: MY_CALENDAR_CONSTANTS.MYP_PROJECT_DEADLINE_NEW,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const DP_PROJECT_DEADLINE_CREATE_OPTION = {
  label: "project:create_dp_deadline",
  key: MY_CALENDAR_CONSTANTS.CREATE_DP_DEADLINE,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const DP_CP_PROJECT_DEADLINE_CREATE_OPTION = {
  label: "project:create_dp_&_cp_deadline",
  key: MY_CALENDAR_CONSTANTS.CREATE_DP_CP_DEADLINE,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const DP_PROJECT_DEADLINE_CREATE_OPTION_STAFF = {
  label: "project:create_ia_ea_deadline",
  key: MY_CALENDAR_CONSTANTS.CREATE_DP_DEADLINE,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const DP_PROJECT_DEADLINE_CREATE_OPTION_NEW = {
  label: "project:create_dp_deadline",
  key: MY_CALENDAR_CONSTANTS.CREATE_DP_DEADLINE_NEW,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const DP_CP_PROJECT_DEADLINE_CREATE_OPTION_NEW = {
  label: "project:create_dp_&_cp_deadline",
  key: MY_CALENDAR_CONSTANTS.CREATE_DP_CP_DEADLINE_NEW,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const DP_PROJECT_DEADLINE_CREATE_OPTION_STAFF_NEW = {
  label: "project:create_ia_ea_deadline",
  key: MY_CALENDAR_CONSTANTS.CREATE_DP_DEADLINE_NEW,
  icon: <CalendarScheduleOutlined variant={"subtle"} />,
  perm: "FeatureFlag:MasterCalendarV2",
};
export const PYP_CREATE_OPTIONS = [
  {
    label: "common:create",
    key: "create",
    isItemGroup: true,
    options: [
      {
        label: "common:quick_task",
        key: "CREATE_QUICK_TASK",
        value: "qt",
        icon: <QuickTaskOutlined variant={"subtle"} />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:le_label",
        key: "CREATE_LE",
        value: "le",
        icon: <LeOutlined variant={"subtle"} />,
        perm: "TeacherPortal:CreateClassroomLE",
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "classRoom:formative_assessment",
        key: "CREATE_FA",
        value: "fmt",
        icon: <FaOutlined variant="subtle" />,
        perm: ENABLE_ASSESSMENTS_IN_PYP,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "classRoom:summative_assessment",
        key: "CREATE_SA",
        value: "smt",
        icon: <SaOutlined variant="subtle" />,
        perm: ENABLE_ASSESSMENTS_IN_PYP,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:video_meeting_lower",
        key: "SCHEDULE_VIDEO_CALL",
        icon: <VideoOutlined variant={"subtle"} />,
        hasTermDependency: false,
      },
      {
        label: "common:worksheet",
        key: "CREATE_WORKSHEET",
        value: ASSESSMENT_TYPE_WORKSHEET,
        icon: <WorksheetClipboardOutlined variant={"subtle"} />,
        perm: "FeatureFlag:ClassroomWorksheet",
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:ai_tutor",
        key: CREATE_AI_TUTOR,
        value: ASSESSMENT_TYPE_AI_TUTOR,
        icon: <AiOutlined variant={"subtle"} />,
        hasTermDependency: true,
        // perm: ENABLE_AI_TUTOR,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
    ],
  },
];
export const PYP_IMPORT_OPTIONS_GROUP = [
  {
    label: "common:import_from",
    key: "Assign",
    isItemGroup: true,
    options: [
      {
        label: "common:unit",
        key: ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP) ? "UNIT" : "IMPORT_LE",
        icon: <UnitPlanOutlined variant={"subtle"} />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:import_from_label_no_grading_periods_tooltip",
      },
      {
        label: "common:library",
        key: "IMPORT_LE_FROM_LE_LIBRARY",
        icon: <LeLibraryOutlined variant={"subtle"} />,
        perm: "TeacherPortal:LELibrary",
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:import_from_label_no_grading_periods_tooltip",
      },
      {
        label: "common:toddle_library",
        key: "IMPORT_FROM_TODDLE_LIBRARY",
        icon: <JournalOutlined variant={"subtle"} />,
        moduleSettingControlParam: TODDLE_LIBRARY_PERM,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:import_from_label_no_grading_periods_tooltip",
      },
    ],
  },
];
export const ASSIGNMENT_CREATE_OPTIONS_NEW = [
  ...PYP_CREATE_OPTIONS,
  ...PYP_IMPORT_OPTIONS_GROUP,
];
export const MYP_CREATE_OPTIONS = [
  {
    label: "common:create",
    key: "create",
    isItemGroup: true,
    options: [
      {
        label: "common:quick_task",
        key: "CREATE_QUICK_TASK",
        value: "qt",
        icon: <QuickTaskOutlined variant={"subtle"} />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "classRoom:formative_assessment",
        key: "CREATE_FA",
        value: "fmt",
        icon: <FaOutlined variant="subtle" />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "classRoom:summative_assessment",
        key: "CREATE_SA",
        value: "smt",
        icon: <SaOutlined variant="subtle" />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:le_label",
        key: "CREATE_LE",
        value: "le",
        icon: <LeOutlined variant="subtle" />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:video_meeting_lower",
        key: "SCHEDULE_VIDEO_CALL",
        icon: <VideoOutlined variant={"subtle"} />,
        hasTermDependency: false,
      },
      {
        label: "common:worksheet",
        key: "CREATE_WORKSHEET",
        value: ASSESSMENT_TYPE_WORKSHEET,
        icon: <WorksheetClipboardOutlined variant={"subtle"} />,
        perm: "FeatureFlag:ClassroomWorksheet",
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:ai_tutor",
        key: CREATE_AI_TUTOR,
        value: ASSESSMENT_TYPE_AI_TUTOR,
        icon: <AiOutlined variant={"subtle"} />,
        hasTermDependency: true,
        // perm: ENABLE_AI_TUTOR,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
    ],
  },
];
export const MYP_IMPORT_OPTIONS_GROUP = {
  label: "common:import_from",
  key: "Assign",
  isItemGroup: true,
  options: [
    {
      label: "common:library",
      key: "IMPORT_LE_FROM_LE_LIBRARY",
      icon: <LeOutlined variant={"subtle"} />,
      perm: "TeacherPortal:LELibraryMyp",
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
    {
      label: "common:unit",
      key: "UNIT",
      icon: <UnitPlanOutlined variant={"subtle"} />,
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
    {
      label: "common:toddle_library",
      key: "IMPORT_FROM_TODDLE_LIBRARY",
      icon: <JournalOutlined variant={"subtle"} />,
      moduleSettingControlParam: TODDLE_LIBRARY_PERM,
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
  ],
};
export const MYP_ASSIGNMENT_OPTIONS_NEW = [
  ...MYP_CREATE_OPTIONS,
  MYP_IMPORT_OPTIONS_GROUP,
];
export const UBD_CREATE_OPTIONS = [
  {
    label: "common:create",
    key: "create",
    isItemGroup: true,
    options: [
      {
        label: "common:quick_task",
        key: "CREATE_QUICK_TASK",
        value: "QUICK_TASK",
        icon: <QuickTaskOutlined variant={"subtle"} />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:assessment",
        key: "CREATE_ASSESSMENT",
        value: "ASSESSMENT",
        icon: <AssessmentAddOutlined variant={"subtle"} />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:le_label",
        key: "CREATE_LE",
        value: "LEARNING_ENGAGEMENT",
        icon: <LeOutlined variant={"subtle"} />,
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:video_meeting_lower",
        key: "SCHEDULE_VIDEO_CALL",
        icon: <VideoOutlined variant={"subtle"} />,
        hasTermDependency: false,
      },
      {
        label: "common:worksheet",
        key: "CREATE_WORKSHEET",
        value: ASSESSMENT_TYPE_WORKSHEET,
        icon: <WorksheetClipboardOutlined variant={"subtle"} />,
        perm: "FeatureFlag:ClassroomWorksheet",
        hasTermDependency: true,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
      {
        label: "common:ai_tutor",
        key: CREATE_AI_TUTOR,
        value: ASSESSMENT_TYPE_AI_TUTOR,
        icon: <AiOutlined variant={"subtle"} />,
        hasTermDependency: true,
        // perm: ENABLE_AI_TUTOR,
        noTermsDisabledTooltip:
          "classRoom:assessment_creation_no_grading_periods_tooltip_with_label_plural",
      },
    ],
  },
];
export const UBD_IMPORT_OPTIONS_GROUP = {
  label: "common:import_from",
  key: "Assign",
  isItemGroup: true,
  options: [
    {
      label: "common:library",
      key: "IMPORT_LE_FROM_LE_LIBRARY",
      icon: <LeLibraryOutlined variant={"subtle"} />,
      perm: "TeacherPortal:LELibraryUbd",
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
    {
      label: "common:unit",
      key: "UNIT",
      icon: <UnitPlanOutlined variant={"subtle"} />,
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
    {
      label: "common:toddle_library",
      key: "IMPORT_FROM_TODDLE_LIBRARY",
      icon: <JournalOutlined variant={"subtle"} />,
      moduleSettingControlParam: TODDLE_LIBRARY_PERM,
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
  ],
};
export const UBD_ASSIGNMENT_OPTIONS_NEW = [
  ...UBD_CREATE_OPTIONS,
  UBD_IMPORT_OPTIONS_GROUP,
];
export const DP_IMPORT_OPTIONS_GROUP = {
  label: "common:import_from",
  key: "Assign",
  isItemGroup: true,
  options: [
    {
      label: "common:library",
      key: "IMPORT_LE_FROM_LE_LIBRARY",
      icon: <LeOutlined variant={"subtle"} />,
      perm: "TeacherPortal:LELibraryMyp",
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
    {
      label: "common:unit",
      key: "UNIT",
      icon: <UnitPlanOutlined variant={"subtle"} />,
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
    {
      label: "common:toddle_library",
      key: "IMPORT_FROM_TODDLE_LIBRARY",
      icon: <JournalOutlined variant={"subtle"} />,
      moduleSettingControlParam: TODDLE_LIBRARY_PERM,
      hasTermDependency: true,
      noTermsDisabledTooltip:
        "classRoom:import_from_label_no_grading_periods_tooltip",
    },
  ],
};
export const DP_ASSIGNMENT_OPTIONS_NEW = [
  ...MYP_CREATE_OPTIONS,
  DP_IMPORT_OPTIONS_GROUP,
];
export const SCORE_DETAIL_CATEGORIES_OPTION = [
  {
    id: "AVERAGE",
    label: "classRoom:class_average",
  },
  {
    id: "HIGHEST",
    label: "classRoom:highest",
  },
  {
    id: "LOWEST",
    label: "classRoom:lowest",
  },
];
export const ASSIGNMENT_TYPE_MAPPING = {
  ASSESSMENT: {
    typeLabel: "common:le_label",
    color: colors.violet500,
    svg: <LeOutlined variant="on" />,
  },
  ASSIGNMENT_RESOURCE: {
    typeLabel: "common:quick_task",
    color: colors.blue500,
    svg: <QuickTaskOutlined variant="on" />,
  },
  ASSIGNMENT_DISCUSSION: {
    typeLabel: "common:discussion",
    color: colors.green500,
    svg: <DiscussionFilledIcon fill={colors.white} />,
  },
  ASSIGNMENT_MEETING: {
    typeLabel: "common:video_call",
    typeLabel2: "common:video_meeting",
    color: colors.pink300,
    svg: <VideoOutlined variant={"on"} />,
  },
};
export const PYP_ASSIGNMENT_TYPE_MAPPING = {
  le: {
    typeLabel: "common:le_label",
    color: colors.violet500,
    svg: <LeOutlined variant="on" />,
  },
  qt: {
    typeLabel: "common:quick_task",
    color: colors.blue500,
    svg: <QuickTaskOutlined variant="on" />,
  },
  worksheet: {
    typeLabel: "common:worksheet",
    color: colors.orange500,
    svg: <WorksheetClipboardOutlined variant="on" />,
  },
  smt: {
    typeLabel: "classRoom:summative_assessment",
    color: colors.teal500,
    svg: <SaOutlined variant={"on"} />,
  },
  fmt: {
    typeLabel: "classRoom:formative_assessment",
    color: colors.yellow500,
    svg: <FaOutlined variant={"on"} />,
  },
  ai_tutor: {
    typeLabel: "common:ai_tutor",
    color: colors.purple500,
    svg: <AiOutlined variant={"on"} />,
  },
};
export const MYP_ASSIGNMENT_TYPE_MAPPING = {
  smt: {
    typeLabel: "classRoom:summative_assessment",
    color: colors.teal500,
    svg: <SaOutlined variant={"on"} />,
  },
  fmt: {
    typeLabel: "classRoom:formative_assessment",
    color: colors.yellow500,
    svg: <FaOutlined variant={"on"} />,
  },
  le: {
    typeLabel: "common:le_label",
    color: colors.violet500,
    svg: <LeOutlined variant="on" />,
  },
  qt: {
    typeLabel: "common:quick_task",
    color: colors.blue500,
    svg: <QuickTaskOutlined variant="on" />,
  },
  worksheet: {
    typeLabel: "common:worksheet",
    color: colors.orange500,
    svg: <WorksheetClipboardOutlined variant="on" />,
  },
  ai_tutor: {
    typeLabel: "common:ai_tutor",
    color: colors.purple500,
    svg: <AiOutlined variant={"on"} />,
  },
};
export const UBD_ASSIGNMENT_TYPE_MAPPING = {
  fmt: {
    typeLabel: "classRoom:formative_assessment",
    color: colors.yellow500,
    svg: <FaOutlined variant={"on"} />,
  },
  pt: {
    typeLabel: "common:performance_task",
    color: colors.blue400,
    svg: <CreateAssessmentSvg fill={colors.white} fill1={colors.blue400} />,
  },
  pri: {
    typeLabel: "classRoom:pre_assessment",
    color: colors.blue400,
    svg: <CreateAssessmentSvg fill={colors.white} fill1={colors.blue400} />,
  },
  se: {
    typeLabel: "common:supplementary_evidence",
    color: colors.blue400,
    svg: <CreateAssessmentSvg fill={colors.white} fill1={colors.blue400} />,
  },
  le: {
    typeLabel: "common:le_label",
    color: colors.violet500,
    svg: <LeOutlined variant={"on"} />,
  },
  qt: {
    typeLabel: "common:quick_task",
    color: colors.blue500,
    svg: <QuickTaskOutlined variant={"on"} />,
  },
  ba: {
    typeLabel: "common:benchmark_assessment",
    color: colors.blue400,
    svg: <CreateAssessmentSvg fill={colors.white} fill1={colors.blue400} />,
  },
  afl: {
    typeLabel: "common:assessment_for_learning",
    color: colors.blue400,
    svg: <CreateAssessmentSvg fill={colors.white} fill1={colors.blue400} />,
  },
  aol: {
    typeLabel: "common:assessment_of_learning",
    color: colors.yellow500,
    svg: <CreateAssessmentSvg fill={colors.white} fill1={colors.yellow500} />,
  },
  smt: {
    typeLabel: "classRoom:summative_assessment",
    color: colors.teal500,
    svg: <SaOutlined variant={"on"} />,
  },
  ai_tutor: {
    typeLabel: "common:ai_tutor",
    color: colors.purple500,
    svg: <AiOutlined variant={"on"} />,
  },
};
export const PYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR = {
  le: {
    typeLabel: "common:le_label",
    color: colors.violet500,
    newColor: "var(--violet-500)",
    dotColor: "var(--violet-500)",
    svg: <LeOutlined variant="on" />,
  },
  qt: {
    typeLabel: "common:quick_task",
    color: colors.blue500,
    newColor: "var(--blue-500)",
    dotColor: "var(--blue-500)",
    svg: <QuickTaskOutlined variant="on" />,
  },
  smt: {
    typeLabel: "classRoom:summative_assessment",
    color: colors.teal500,
    newColor: "var(--teal-500)",
    dotColor: "var(--teal-500)",
    svg: <SaOutlined variant={"on"} />,
    perm: ENABLE_ASSESSMENTS_IN_PYP,
  },
  fmt: {
    typeLabel: "classRoom:formative_assessment",
    color: colors.yellow500,
    newColor: "var(--yellow-500)",
    dotColor: "var(--yellow-500)",
    svg: <FaOutlined variant={"on"} />,
    perm: ENABLE_ASSESSMENTS_IN_PYP,
  },
  worksheet: {
    typeLabel: "common:worksheet",
    color: colors.orange500,
    newColor: "var(--pink-500)",
    dotColor: "var(--pink-500)",
    icon: <WorksheetClipboardOutlined variant={"subtle"} />,
    perm: "FeatureFlag:ClassroomWorksheet",
  },
  ai_tutor: {
    typeLabel: "common:ai_tutor",
    color: colors.purple500,
    newColor: "var(--purple-500)",
    dotColor: "var(--purple-500)",
    icon: <AiOutlined variant={"on"} />,
    // perm: ENABLE_AI_TUTOR,
  },
};
export const MYP_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR = {
  smt: {
    typeLabel: "classRoom:summative_assessment",
    color: colors.teal500,
    newColor: "var(--teal-500)",
    dotColor: "var(--teal-500)",
    svg: <SaOutlined variant={"on"} />,
  },
  fmt: {
    typeLabel: "classRoom:formative_assessment",
    color: colors.yellow500,
    newColor: "var(--yellow-500)",
    dotColor: "var(--yellow-500)",
    svg: <FaOutlined variant={"on"} />,
  },
  le: {
    typeLabel: "common:le_label",
    color: colors.violet500,
    newColor: "var(--violet-500)",
    dotColor: "var(--violet-500)",
    svg: <LeOutlined variant="on" />,
  },
  qt: {
    typeLabel: "common:quick_task",
    color: colors.blue500,
    newColor: "var(--blue-500)",
    dotColor: "var(--blue-500)",
    svg: <QuickTaskOutlined variant="on" />,
  },
  worksheet: {
    typeLabel: "common:worksheet",
    color: colors.orange500,
    newColor: "var(--pink-500)",
    dotColor: "var(--pink-500)",
    icon: <WorksheetClipboardOutlined variant={"subtle"} />,
    perm: "FeatureFlag:ClassroomWorksheet",
  },
  ai_tutor: {
    typeLabel: "common:ai_tutor",
    color: colors.purple500,
    newColor: "var(--purple-500)",
    dotColor: "var(--purple-500)",
    icon: <AiOutlined variant={"on"} />,
    // perm: ENABLE_AI_TUTOR,
  },
};
export const UBD_ASSIGNMENT_TYPE_MAPPING_FOR_CALENDAR = {
  le: {
    typeLabel: "common:le_label",
    color: colors.violet500,
    newColor: "var(--violet-500)",
    dotColor: "var(--violet-500)",
    svg: <LeOutlined variant="on" />,
  },
  qt: {
    typeLabel: "common:quick_task",
    color: colors.blue500,
    newColor: "var(--blue-500)",
    dotColor: "var(--blue-500)",
    svg: <QuickTaskOutlined variant="on" />,
  },
  as: {
    typeLabel: "common:assessment",
    color: colors.blue400,
    newColor: "var(--teal-500)",
    dotColor: "var(--teal-500)",
    icon: <AssessmentAddOutlined variant={"subtle"} />,
  },
  worksheet: {
    typeLabel: "common:worksheet",
    color: colors.orange500,
    newColor: "var(--pink-500)",
    dotColor: "var(--pink-500)",
    icon: <WorksheetClipboardOutlined variant={"subtle"} />,
    perm: "FeatureFlag:ClassroomWorksheet",
  },
  ai_tutor: {
    typeLabel: "common:ai_tutor",
    color: colors.purple500,
    newColor: "var(--purple-500)",
    dotColor: "var(--purple-500)",
    icon: <AiOutlined variant={"on"} />,
    // perm: ENABLE_AI_TUTOR,
  },
};
export const CURRICULUM_WISE_ASSIGNMENT_TYPE_MAPPING = {
  IB_PYP: {
    key: "contentTypes",
    value: ASSIGNMENT_TYPE_MAPPING,
  },
  IB_MYP: {
    key: "assessmentTypes",
    value: MYP_ASSIGNMENT_TYPE_MAPPING,
  },
  UBD: {
    key: "assessmentTypes",
    value: UBD_ASSIGNMENT_TYPE_MAPPING,
  },
  IB_DP: {
    key: "assessmentTypes",
    value: MYP_ASSIGNMENT_TYPE_MAPPING,
  },
};
export const VIDEO_MEETING = {
  typeLabel: "common:video_meeting",
  color: colors.pink200,
  newColor: "var(--red-500)",
  dotColor: "var(--red-500)",
};
export const PUBLISHED_STUDENT_ASSIGNMENT_STATUS = [
  { label: "classRoom:submission_pending", value: "SUBMISSION_PENDING" },
  {
    label: "classRoom:submission_not_required",
    value: "SUBMISSION_NOT_REQUIRED",
  },
  { label: "classRoom:overdue", value: "OVERDUE" },
  {
    label: "classRoom:request_resubmission",
    value: "REQUEST_RESUBMISSION",
  },
  {
    label: "classRoom:request_resubmission_overdue",
    value: "REQUEST_RESUBMISSION_OVERDUE",
  },
];
export const PUBLISHED_STUDENT_ASSIGNMENT_LOCKING_SUBMISSION_STATUS = [
  { label: "classRoom:not_submitted", value: "NOT_SUBMITTED" },
  {
    label: "classRoom:resubmission_not_submitted",
    value: "RESUBMISSION_NOT_SUBMITTED",
  },
];
export const ARCHIVED_STUDENT_ASSIGNMENT_STATUS = [
  { label: "classRoom:turned_in", value: "TURNED_IN_ON_TIME" },
  { label: "classRoom:turned_in_late", value: "TURNED_IN_LATE" },
  { label: "classRoom:evaluated", value: "EVALUATED" },
  { label: "classRoom:completed", value: "COMPLETED" },
];
export const ARCHIVED_STUDENT_ASSIGNMENT_STATUS_V2 = [
  { label: "classRoom:turned_in", value: "TURNED_IN_ON_TIME" },
  { label: "classRoom:turned_in_late", value: "TURNED_IN_LATE" },
  { label: "classRoom:evaluated", value: "EVALUATED" },
  { label: "classRoom:completed", value: "COMPLETED" },
  { label: "classRoom:excused", value: "EXCUSED" },
];
export const NAME = "classRoom";
export const INIT_FILTERS = "INIT_FILTERS" + " " + NAME;
export const UPDATE_FILTERS = "UPDATE_FILTERS" + " " + NAME;
export const UPDATE_COURSE_ID = "UPDATE_COURSE_ID" + " " + NAME;
export const UPDATE_TODO_FILTERS = "UPDATE_TODO_FILTERS" + " " + NAME;
export const SET_COURSE_ID = "SET_COURSE_ID" + " " + NAME;
export const SET_STUDENT_DETAIL_FILTERS =
  "SET_STUDENT_DETAIL_FILTERS" + " " + NAME;
export const SET_PDFTRON_INSTANCE = "SET_PDFTRON_INSTANCE" + " " + NAME;
export const INIT_STUDENT_DETAIL_FILTERS =
  "INIT_STUDENT_DETAIL_FILTERS" + " " + NAME;
export const UPDATE_CLASSROOM_FILTERS = "UPDATE_CLASSROOM_FILTERS" + " " + NAME;
export const SET_CURRICULUM_PROGRAM = "SET_CURRICULUM_PROGRAM" + " " + NAME;
export const SET_SHOULD_NAVIGATE_TO_FIRST_STUDENT_ASSIGNMENT =
  "SET_SHOULD_NAVIGATE_TO_FIRST_STUDENT_ASSIGNMENT" + " " + NAME;
export const SET_ALL_SUBMISSIONS_SCROLL_POSITION =
  "SET_ALL_SUBMISSIONS_SCROLL_POSITION" + " " + NAME;
export const SET_AI_EVALUATION_STATUS =
  "SET_ASSESSMENT_EVALUATION_STATUS" + " " + NAME;
export const RESET_AI_EVALUATION_STATUS =
  "RESET_AI_EVALUATION_STATUS" + " " + NAME;
export const UPDATE_HIGHLIGH_TASK_ID = "UPDATE_HIGHLIGH_TASK_ID" + " " + NAME;
export const SET_AI_CONVERSATION_ANALYSING_STATUS =
  "SET_AI_CONVERSATION_ANALYSING_STATUS" + " " + NAME;
export const UPDATE_AI_DATA = "UPDATE_AI_DATA" + " " + NAME;
export const UPDATE_EVALUATION_DATA = "UPDATE_EVALUATION_DATA" + " " + NAME;
export const SET_COURSE_FLOW_RESOURCE_DATA_FOR_REFETCH =
  "SET_COURSE_FLOW_RESOURCE_DATA_FOR_REFETCH" + " " + NAME;
export const SET_AI_GRADING_PROGRESS = "SET_AI_GRADING_PROGRESS" + " " + NAME;
export const UPDATE_STUDENT_ASSIGNMENT_LINK_SHORT_URLS_MAPPING =
  "UPDATE_STUDENT_ASSIGNMENT_LINK_SHORT_URLS_MAPPING" + " " + NAME;
export const SET_ELEMENT_RATING_MUTATION_IN_PROGRESS =
  "SET_ELEMENT_RATING_MUTATION_IN_PROGRESS" + " " + NAME;

export const SUBMISSION_OPTIONS_V2 = [
  "SUBMISSION_PENDING",
  "OVERDUE",
  "TURNED_IN_ON_TIME",
  "TURNED_IN_LATE",
  "REQUEST_RESUBMISSION",
  "REQUEST_RESUBMISSION_OVERDUE",
  "NOT_SUBMITTED",
  "RESUBMISSION_NOT_SUBMITTED",
];

export const INCLUDE_ITEM_TYPES_FOR_UNREAD_MESSAGES_COUNT = [
  // old type
  "STUDENT_ASSIGNMENT_SUBMISSION",

  // new types after activity log
  "STUDENT_ASSIGNMENT_SUBMISSION_DONE",
  "STUDENT_ASSIGNMENT_RETURNED_SUBMISSION_SUBMITTED",
  "STUDENT_ASSIGNMENT_WORKSHEET_SUBMITTED",
  "STUDENT_ASSIGNMENT_WORKSHEET_RESUBMISSION_SUBMITTED",

  // ai tutor submit type
  "STUDENT_ASSIGNMENT_SUBMIT_AI_CONVERSATION_SESSION",
];

export const INCLUDE_ITEM_TYPES_FOR_STUDENT_UNREAD_MESSAGES_COUNT = [
  "ASSIGNMENT_ASSIGNED",
  "ASSIGNMENT_ASSIGNED_BACKDATED",
];
